<template>
  <div>
    <app-header></app-header>
    <div class="member-top">
      <div class="member-info">
        <Avatar
          v-if="loginUser.pic"
          size="100"
          :src="concatImageUrl(loginUser.pic, 100, 100, true)"
        />
        <Avatar
          v-else
          size="100"
          :src="require('../../assets/images/v3/avatar-default.png')"
        />
        <div class="member-text">
          <p>{{ loginUser.nickName }}</p>
          <p>天道酬勤，坚持就是胜利，加油吧！</p>
        </div>
        <div class="member-integral">
          <template v-if="integralStatistics.IsCheckInfTask"
            ><Button
              v-if="integralStatistics.isSignIn == 1"
              type="warning"
              size="large"
              shape="circle"
              long
              disabled
              >已签到 </Button
            ><Button
              v-else
              type="warning"
              size="large"
              shape="circle"
              long
              @click="signIn"
              >每日签到
            </Button></template
          >
        </div>
      </div>
    </div>
    <!-- 机构定制的班级选择功能 -->
    <div
      class="custom-class"
      v-if="$customIds.includes(siteConfig.agencyId)"
    >
      <!-- <span>我的班级：</span> -->
      <div>
        <Select
          v-model="gradeValue"
          @on-change="changeSrfId"
          style="width: 200px"
        >
          <Option
            v-for="item in gradeList"
            :value="item.value"
            :key="item.value"
            >{{ item.label }}</Option
          >
        </Select>
      </div>
    </div>
    <div class="member-body">
      <div class="member-sidebar">
        <h3 class="sidebar-title"><i></i>学习中心</h3>
        <ul
          class="sidebar-nav"
          v-if="!$customIds.includes(siteConfig.agencyId)"
        >
          <li
            :class="{
              selected: routerPath == '/member/' || routerPath == '/member',
            }"
          >
            <i class="sidebar-line"></i>
            <router-link :to="{ name: 'MemberCenter' }">
              <Icon custom="ich-icon ich-icon-u-course" size="18" /><span
                >我的课程</span
              >
            </router-link>
          </li>
          <li
            :class="{
              selected:
                routerPath.indexOf('/member/answer') > -1 ||
                routerPath.indexOf('/member/question') > -1,
            }"
            v-if="loginUser.ugid == 4 || loginUser.ugid == 5"
          >
            <i class="sidebar-line"></i>
            <router-link :to="{ name: 'Answer' }">
              <Icon custom="ich-icon ich-icon-u-question" size="18" /><span
                >我的答疑</span
              >
              <Badge :count="Number(answerCount)"></Badge>
            </router-link>
          </li>
          <li
            v-else
            :class="{ selected: routerPath.indexOf('/member/question') > -1 }"
          >
            <i class="sidebar-line"></i>
            <router-link :to="{ name: 'Question' }">
              <Icon custom="ich-icon ich-icon-u-question" size="18" /><span
                >我的提问</span
              >
              <Badge :count="Number(questionCount)"></Badge>
            </router-link>
          </li>
          <li
            :class="{ selected: routerPath.indexOf('/member/order') > -1 }"
            v-if="loginUser.ugid != 6"
          >
            <i class="sidebar-line"></i>
            <router-link :to="{ name: 'MemberOrder' }">
              <Icon custom="ich-icon ich-icon-u-order" size="18" /><span
                >订单管理</span
              >
              <Badge :count="Number(orderCount)"></Badge>
            </router-link>
          </li>
          <li :class="{ selected: routerPath.indexOf('/member/class') > -1 }">
            <i class="sidebar-line"></i>
            <router-link :to="{ name: 'Class' }">
              <Icon custom="ich-icon ich-icon-u-class" size="18" /><span
                >我的班级</span
              >
            </router-link>
          </li>
          <li :class="{ selected: routerPath.indexOf('/member/live') > -1 }">
            <i class="sidebar-line"></i>
            <router-link :to="{ name: 'Live' }">
              <Icon custom="ich-icon ich-icon-u-live" size="18" /><span
                >我的直播</span
              >
            </router-link>
          </li>
          <li :class="{ selected: routerPath.indexOf('/member/signing') > -1 }">
            <i class="sidebar-line"></i>
            <router-link :to="{ name: 'Signing' }">
              <Icon custom="ich-icon ich-icon-u-order" size="18" /><span
                >我的协议</span
              >
            </router-link>
          </li>
        </ul>
        <!-- 定制化菜单 -->
        <ul class="sidebar-nav" v-else>
          <li :class="{ selected: routerPath.indexOf('/member/info') > -1 }">
            <i class="sidebar-line"></i>
            <router-link :to="{ name: 'StudentInfo' }">
              <Icon custom="ich-icon ich-icon-u-order" size="18" /><span
                >学员信息</span
              >
            </router-link>
          </li>
          <li
            :class="{
              selected: routerPath.indexOf('/member/plan') > -1,
            }"
          >
            <i class="sidebar-line"></i>
            <router-link :to="{ name: 'StudyPlan' }">
              <Icon custom="ich-icon ich-icon-u-course" size="18" /><span
                >学习计划</span
              >
            </router-link>
          </li>
          <li :class="{ selected: routerPath.indexOf('/member/class') > -1 }">
            <i class="sidebar-line"></i>
            <router-link :to="{ name: 'Class' }">
              <Icon custom="ich-icon ich-icon-u-class" size="18" /><span
                >我的班级</span
              >
            </router-link>
          </li>
        </ul>
        <h3 class="sidebar-title"><i></i>个人中心</h3>
        <ul class="sidebar-nav">
          <li
            :class="{ selected: routerPath.indexOf('/member/integral') > -1 }"
          >
            <i class="sidebar-line"></i>
            <router-link :to="{ name: 'Integral' }">
              <Icon custom="ich-icon ich-icon-u-integral" size="18" /><span
                >我的积分</span
              >
            </router-link>
          </li>
          <li :class="{ selected: routerPath.indexOf('/member/account') > -1 }">
            <i class="sidebar-line"></i>
            <router-link :to="{ name: 'Account' }">
              <Icon custom="ich-icon ich-icon-u-account" size="18" /><span
                >账号管理</span
              >
            </router-link>
          </li>
          <li :class="{ selected: routerPath.indexOf('/member/message') > -1 }">
            <i class="sidebar-line"></i>
            <router-link :to="{ name: 'Message' }">
              <Icon custom="ich-icon ich-icon-u-message" size="18" /><span
                >消息中心</span
              >
              <Badge :count="Number(messageCount)"></Badge>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="member-main">
        <router-view></router-view>
      </div>
    </div>
    <app-footer></app-footer>
    <Modal
      v-model="signModel"
      :closable="false"
      :mask-closable="false"
      footer-hide
      class-name="vertical-center-modal"
    >
      <div style="text-align: center">
        <img
          src="../../assets/images/sign.png"
          alt="abc"
          style="margin: 0 auto"
        />
        <p style="margin: 20px auto; font-size: 18px">
          恭喜您获得
          <span style="color: #ff6a00; margin: 0 5px"> {{ signIntegral }}</span
          >积分
        </p>
        <div style="width: 130px; margin: 0 auto">
          <Button type="primary" shape="circle" long @click="viewIntegral"
            >查看积分</Button
          >
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import AppHeader from "../../components/common/AppHeader.vue";
import AppFooter from "../../components/common/AppFooter";

import { siteMixin } from "../../utils/mixin";

import { user, custom, order } from "../../request";

export default {
  mixins: [siteMixin],
  data() {
    return {
      routerPath: "",
      answerCount: "0",
      orderCount: 0,
      courseIdSet: "",
      messageCount: "0",
      questionCount: "0",
      integralStatistics: {},
      //积分信息
      signModel: false,
      signIntegral: 0,
      gradeList: [],
      gradeValue: "1",
    };
  },

  beforeUpdate() {
    this.routerPath = this.$route.path;
  },

  mounted() {
    this.getIntegralInfo();
    this.getUserCourseList();
    this.getMessageCount();
    this.getQuestionCount();
    this.getOrderCount();
    this.getGradeList();
  },

  methods: {
    getIntegralInfo() {
      user.getMyIntegral(this.loginUser.userId).then((res) => {
        if (res.status == 1) {
          this.integralStatistics = res.data;
        }
      });
    },

    signIn() {
      user
        .signIn(this.siteConfig.agencyId, this.loginUser.userId)
        .then((res) => {
          //console.log('sign',res);
          if (res.status === 1) {
            this.signIntegral = res.data.changeIntegral;
            this.signModel = true;
            this.getIntegralInfo();
          }
        });
    },

    viewIntegral() {
      this.signModel = false;

      this.$router.push({
        name: "Integral",
      });
    },

    getUserCourseList() {
      if (this.siteConfig.agencyId > 0) {
        this.getAnswerCount();
      }

      user.getUserCourseList(this.loginUser.userId).then((res) => {
        //console.log("userCourse", res);
        if (res.status === 1) {
          this.setUserCourseList(res.data);

          if (this.siteConfig.agencyId == 0) {
            let courseIds = "";

            this.userCourseList.forEach((item) => {
              if (courseIds) courseIds += ",";
              courseIds += item.courseId;
            });
            this.courseIdSet = courseIds;
            this.getAnswerCount();
          }
        }
      });
    },

    getAnswerCount() {
      user
        .getNotAnswerCount(
          this.siteConfig.agencyId,
          this.courseIdSet,
          this.loginUser.userId
        )
        .then((res) => {
          //console.log(res);
          if (res.status === 1) {
            this.answerCount = res.data;
          }
        });
    },

    getQuestionCount() {
      user.getQuestionNotReadCount(this.loginUser.userId).then((res) => {
        //console.log(res);
        if (res.status === 1) {
          this.questionCount = res.data;
        }
      });
    },

    getOrderCount() {
      order.getMaterialOrderCount(this.loginUser.userId).then((res) => {
        if (res.status === 1) {
          this.orderCount = res.data;
        }
      });
    },

    getMessageCount() {
      user.getNotMessageCount(this.loginUser.userId).then((res) => {
        //console.log(res);
        if (res.status === 1) {
          this.messageCount = res.data;
        }
      });
    },

    getGradeList() {
      custom
        .getGradeList(this.siteConfig.agencyId, this.loginUser.userId)
        .then((res) => {
          console.log("gradeList", res);
          if (res.status === 1) {
            const tempData = res.data;
            if (tempData.length > 0) {
              const srfId = tempData[0].srfId;
              this.gradeValue = srfId.toString();
              this.setSrfId(srfId.toString());
              localStorage.setItem("srfId", srfId.toString());
            }
            this.gradeList = tempData.map((item) => {
              return {
                value: item.srfId.toString(),
                label: item.GradeName,
              };
            });
            //this.gradeList.push({ label: "KKKKK", value: "999" });
          }
        });
    },
    changeSrfId(value) {
      // console.log("changeSrfId", value);
      this.setSrfId(value);
      localStorage.setItem("srfId", value.toString());
    },
  },

  components: {
    AppHeader,
    AppFooter,
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/var";

.member-top {
  width: 100%;
  height: 318px;
  padding-top: 145px;
  background: url("../../assets/images/v3/member-banner.png") no-repeat center
    top;

  .member-info {
    display: flex;
    align-items: center;
    width: 1200px;
    margin: 0 auto;

    .member-text {
      flex: 1;
      margin-left: 20px;
      color: #fff;

      p {
        &:first-child {
          font-size: 22px;
        }
      }
    }

    .member-integral {
      width: 130px;
    }
  }
}

.member-body {
  width: 1200px;
  margin: 20px auto;
  display: flex;
  align-items: stretch;
}

.member-sidebar {
  width: 200px;
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  border-radius: 6px;

  .sidebar-title {
    padding: 18px 20px 12px 20px;
    font-size: 16px;
    border-bottom: 3px solid #f7f7f7;
    margin-bottom: 2px;

    i {
      display: inline-block;
      vertical-align: -0.1em;
      // width: 6px;
      // height: 16px;
      // sultan
      width: 4px;
      height: 14px;
      background: linear-gradient(#2da6fe, #2680fa);
      margin-right: 10px;
      border-radius: 6px;
    }
  }

  .sidebar-nav {
    width: 100%;

    li {
      width: 200px;
      height: 50px;
      line-height: 50px;
      margin-bottom: 2px;

      .sidebar-line {
        .inline-block();
        width: 6px;
        height: 50px;
      }

      a {
        margin-left: 10px;
        .inline-block();
        color: #868686;
        font-size: 16px;

        i {
          width: 24px;
          height: 24px;
          padding: 3px;
        }

        span {
          vertical-align: -0.1em;
          margin-left: 5px;
          margin-right: 15px;
        }
      }

      &.selected,
      &:hover {
        background: #eee;

        a {
          color: #41a1fc;
        }
      }

      &:hover {
        .sidebar-line {
          background: #eee;
        }
      }

      &.selected {
        .sidebar-line {
          background: linear-gradient(#2da6fe, #2680fa);
        }
      }
    }
  }
}

.member-main {
  margin-left: 30px;
  width: 970px;
}

// 班级选择
.custom-class {
  width: 1200px;
  margin: 20px auto;
  height: 60px;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  padding: 24px;
}
</style>
